import React from "react";
import BookList from "../components/books/BookList";

const Home = () => {
    return <BookList />;
};

export default Home;
